import { experiment } from "@faire/web--source/common/settings/declarations/experiment";

/**
 * Batch 8 Sign Up Google CTA Change
 */
export const FE_BATCH_8_SIGN_UP_GOOGLE_CTA_CHANGE_250310 = experiment({
  name: "FE_BATCH_8_SIGN_UP_GOOGLE_CTA_CHANGE_250310",
  identifier: "SessionToken",
  client: "RETAILER",
  notifyAfter: "2025-05-10",
  defaultValue: false,
  productArea: "LOGGED_OUT_RETAILERS",
});
